<script lang="ts">
  import type { CallTile } from '../call.svelte';
  import Avatar from './Avatar.svelte';

  let { tile }: { tile: CallTile } = $props();
  let videoEl = $state<HTMLVideoElement | undefined>();

  $effect(() => {
    const element = videoEl;
    const track = tile.video;
    if (!element || !track) return;
    track.attach(element);
    return () => {
      track.detach(element);
    };
  });
</script>

<div class={`tile ${tile.screen ? 'screen' : ''} ${tile.speaking ? 'speaking' : ''}`}>
  {#if tile.video}
    <video bind:this={videoEl} autoplay playsinline muted={tile.local}></video>
  {:else}
    <Avatar name={tile.name} size={64} />
  {/if}
  <span class="tile-name">{tile.name}{tile.local ? ' (you)' : ''}{tile.screen ? ' · screen' : ''}</span>
</div>
